import Localization from "@/Localization"
import CommonMethods from "@/CommonMethods"
import { setTimeout } from "timers";

export default class SliderControl {
    // wraps https://github.com/seiyria/bootstrap-slider

    private content: JQuery;
    private slider: JQuery;
    private sliderLabel: JQuery;
    private sliderValue: JQuery;
    private sliderValueWithUnit: JQuery;
    private sliderContainer: JQuery;
    private oldValue: number;

    public get Content() { return this.content; }

    public get Label() { return this.sliderLabel; }
    public get Value() { return this.sliderValueWithUnit; }
    public get Slider() { return this.sliderContainer; }

    public get rangeMin(): number { return (this.slider.slider("getAttribute", "min")) as any }
    public get rangeMax(): number { return (this.slider.slider("getAttribute", "max")) as any }

    public getValue(): number {
        this.oldValue = <any>(this.slider.slider("getValue"));
        return this.oldValue;
    }

    constructor(label: string, rangeMin: number, rangeMax: number, rangeStep: number, unit: string, changeFunctionName: (id: string, newValue: number) => void, id: string, domId: string, enabled: boolean) {
        this.createSlider(label, rangeMin, rangeMax, rangeStep, unit, changeFunctionName, id, domId, enabled);
    }

    public updateSliderAttribute(attribute: string, newValue: any) {
        this.slider.slider("setAttribute", attribute, newValue);
    }

    // Returns true if value has changed, false otherwise
    public setValue(newValue: number, formatter: (v: number) => string = x => x.toString(), triggerChangeEvent = false): boolean {
        const newValueFormatted = formatter(newValue);
        this.oldValue = this.getValue();
        if (formatter(this.oldValue) === newValueFormatted) {
            return false;
        }

        this.slider.slider("setValue", newValue, false, triggerChangeEvent);
        this.sliderValue.editable("setValue", newValueFormatted);
        this.oldValue = newValue;

        return true;
    }

    public forceSliderUpdate() {
        // Intention is to reevaluate the sliders html attributes, this can happen if the initialisation is somewhat out of order
        this.slider.slider("setValue", this.getValue());
    }

    private resetSliderControl() {
        this.slider.slider("setValue", this.oldValue);
        setTimeout(() =>
            this.sliderValue.editable("setValue", Localization.formatNumber3Digits(this.oldValue))
            , 0
        );
    }

    private handleMouseWheel = (event: any) => {
        var slideScaleFactor = 10;
        var slideBaseFactor: number = this.slider.data("slider-step");
        var finalValue = this.getValue();

        if (event.ctrlKey) {
            slideScaleFactor = 1;
        }

        if (event.shiftKey) {
            slideScaleFactor = 100;
        }

        if (event.wheelDelta > 0 || event.detail < 0) {
            finalValue += slideScaleFactor * slideBaseFactor;
            if (finalValue > this.slider.data("slider-max")) {
                finalValue = this.slider.data("slider-max");
            }
        } else {
            finalValue -= slideScaleFactor * slideBaseFactor;
            if (finalValue < this.slider.data("slider-min")) {
                finalValue = this.slider.data("slider-min");
            }
        }

        if (this.slider.slider("isEnabled")) {
            this.setValue(finalValue, Localization.formatNumber3Digits, true);
        }

        event.preventDefault();
    }

    private createSlider(label: string, rangeMin: number, rangeMax: number, rangeStep: number, unit: string, changeFunctionName: (id: string, newValue: number) => void, id: string, domId: string, enabled: boolean) {
        var options: XEditableOptions = {
            display: (value: string, sourceData) => {
                $(this.sliderValue).html(Localization.formatNumber3Digits(Localization.parseLocaleNumber(value)));
            }
        };

        this.sliderValue = $("<span>", {
            id: domId + "-value",
            type: "number",
            "class": "siteEditable minWidth40px",
        });

        this.sliderValue.editable(options);

        var inputDomElement = $("<input>", {
            //                id: domId,
            'data-slider-min': rangeMin,
            'data-slider-max': rangeMax,
            'data-slider-step': rangeStep,
            'data-slider-tooltip': "hide",
            "class": "siteTreeSlider sliderInput"
        });

        // we need the container, first and foremost, to be able create the slider, because that guy is placed besides the <input> element!
        this.sliderContainer = $("<span>", { "class": "sliderControl" });
        this.sliderContainer.append(inputDomElement);
        this.sliderContainer.get(0).addEventListener('mousewheel', this.handleMouseWheel, false);
        this.sliderContainer.get(0).addEventListener('DOMMouseScroll', this.handleMouseWheel, false);

        this.sliderValue.text(rangeMin);

        this.sliderValue.on('save', (e, params) => {
            let value: number = Localization.parseLocaleNumber(params.newValue);
            if (!isFinite(value)) {
                this.resetSliderControl();
                return;
            }

            this.oldValue = value;
            inputDomElement.slider("setValue", value, false);
            changeFunctionName(id, value);
        });

        var updateFunction = () => {
            let value = this.getValue();

            this.sliderValue.editable('setValue', Localization.formatNumber3Digits(value));
            changeFunctionName(id, value);
        };

        this.slider = inputDomElement.slider({ value: 0 }); // returns inputDomElement, not the created slider...
        this.slider.on("change", updateFunction);

        this.sliderLabel = $("<span>", { html: label, style: "margin-right: 4px;" });

        this.sliderValueWithUnit = $("<span>", { class: "sliderValue" })
            .append(this.sliderValue)
            .append($("<span>", { html: unit, style: "margin-left: 4px;" }));

        this.content = $(`<span style="display: flex;">`)
            .append(this.sliderLabel)
            .append(this.sliderValueWithUnit)
            .append(this.sliderContainer);

        // Prevent enabling of this slider, if he is not usable because of range limits
        this.slider.on("slideEnabled", () => {
            if (rangeMin === rangeMax) {
                this.slider.slider('disable');
            }
        });

        this.slider.slider(enabled ? 'enable' : 'disable');
        this.sliderValue.editable(enabled ? 'enable' : 'disable');

        this.sliderValue.editable('setValue', Localization.formatNumber3Digits(this.getValue()));
        this.sliderValue.on("shown",
            (e, editable) => {
                editable.input.$input.on("keydown", (evt) => { // keydown != keypress! the keycodes between those two events are totally different
                    CommonMethods.validateKeyInputForNumber(evt, true, true);
                });
            });
    }
}
